import { MainTemplate } from "./components/MainTemplate";
import "./styles/global.css";

function App() {
  return (
    <div className="App">
      <MainTemplate />
    </div>
  );
}

export default App;
